import { canonicalize } from '@gridfit/core/canonical'
import type { JsonValue } from '@gridfit/core/canonical'

/**
 * The react-query key for a named query and its params (design §3.3).
 *
 * LOAD-BEARING, not tidiness. The server matches the fragments it returns to
 * the `observing` bindings the caller declared. If the client's cache key and
 * the binding it sent are not derived from the same bytes, fragments come
 * back and land under a key nothing is subscribed to — the screen stays
 * stale with no error anywhere, which is precisely the failure the fragment
 * protocol exists to prevent.
 *
 * `canonicalize` is RFC 8785 (JCS) from `@gridfit/core/canonical` — the SAME
 * function the ledger uses to seal event payloads. Key order, number format
 * and string escaping are therefore identical on both sides by construction,
 * rather than by `JSON.stringify` happening to agree today.
 */
export function queryKeyFor(name: string, params: unknown): readonly [string, string] {
  return [name, canonicalize(params as JsonValue)]
}
